import Header from './../../../components/Header/BarOther.vue';
import FooterOther from './../../../components/Footer/FooterOther.vue';

// import VideoBg from 'vue-videobg'; //视频背景插件
import { Message } from 'element-ui';

import api from '../../../api.js';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import $ from 'jquery';
const axios = require('axios');

$(window).scroll(function () {
  let a = document.documentElement.scrollTop;
  if (a > 0) {
    $('#heard1').addClass('sticky');
  } else {
    $('#heard1').removeClass('sticky');
  }
});
export default {
  name: 'mainww',
  components: { Header, FooterOther },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  data() {
    var checkEmail = (rule, value, cb) => {
     
      //  验证邮箱的正则表达式
      const regEmail =/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        console.log(33)
        // 合法邮箱
        return cb();
      }
      cb(new Error('Please input a valid email address'));
    };
    let that = this;
    return {
      cardList: [
        {
          id: 1,
          path: 'https://static.wixstatic.com/media/11062b_06dfa7d722434df3924f579b5be62ae7~mv2.jpeg/v1/fill/w_1568,h_922,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_06dfa7d722434df3924f579b5be62ae7~mv2.jpeg',
        },
        {
          id: 2,
          path: 'https://static.wixstatic.com/media/11062b_3617dc08bc644a038066bf9f7d2dcc60~mv2.jpg/v1/fill/w_1960,h_1152,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_3617dc08bc644a038066bf9f7d2dcc60~mv2.jpg',
        },
        {
          id: 3,
          path: 'https://static.wixstatic.com/media/ff94a6c09aff4ad2961bea46a1afad37.jpg/v1/fill/w_1960,h_1152,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/ff94a6c09aff4ad2961bea46a1afad37.jpg',
        },
        {
          id: 4,
          path: 'https://static.wixstatic.com/media/d2418e4ab94246c690f87ebe383e943b.jpg/v1/fill/w_1960,h_1152,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/d2418e4ab94246c690f87ebe383e943b.jpg',
        },
      ],
      email: '',
      isShow:false,
      visible: false,
      isHover: false,
      index: 0,
      info: {
        name: '',
        email: '',
        msg: '',
      },
      rules: {
        name: [{ required: true, message: 'required', trigger: 'blur' }],
        email: [
          { required: true, message: 'required', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' },
        ],
        msg: [{ required: true, message: 'required', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    handleMouseOver(index) {
      this.isHover = true;
      this.index = index;
    },
    handleMouseOut(index) {
      this.isHover = false;
      this.index = 0;
    },
    handleScroll(e) {
      let scrollTo = document.documentElement.scrollTop;
      console.log(scrollTo);
    },
    openUrl() {
      window.open('https://www.minderworks.com/login', '_self');
    },
    closem(){
      this.isShow=false
    },
    submit() {
      var that = this
     
      that.$refs['form'].validate((valid) => {
        if (valid) {
          axios
            .get(
              api.savePersonMsg +
                '?personName=' +
                that.info.name +
                '&personEmail=' +
                that.info.email +
                '&personContent=' +
                that.info.msg,
            )

            .then(function (res) {
              
              if (
                res.data.code == 200 &&
                res.data.data.personMessage == '发送成功'
              ) { 
                // Message({ message: '发送成功！', type: 'success' });
                that.isShow = true
                setTimeout(function(){
                  that.isShow = false
                },2000)
                return;
              } else {
                Message.error('操作失败！请重试');
                return;
              }
            })
        } else {
          return false;
        }
      });
      // if(!this.info.email) return Message({message: '请输入邮箱！',type: 'warning'});
      // if(!this.info.name) return Message({message: '请输入姓名！',type: 'warning'});
      // if(!this.info.msg) return Message({message: '请输入内容！',type: 'warning'});
    },
    goUrl(index) {
      switch (index) {
        case 1:
          this.$router.push({
            path: 'quailty',
            query: {
              navIndex: 2,
            },
          });
          break;
        case 2:
          this.$router.push({
            path: '/vendor',
            query: {
              navIndex: 4,
            },
          });
          break;
        case 3:
          this.$router.push({
            path: '/product',
            query: {
              navIndex: 5,
            },
          });
          break;
        case 4:
          this.$router.push({
            path: 'container',
            query: {
              navIndex: 3,
            },
          });
          break;
      }
    },
    swiperchange(i) {
      console.log(100);
    },
  },
};
